"use strict";

var _defineProperty = require("/Users/nicholasbucher/Documents/code/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/defineProperty");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MiniMap = MiniMap;
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _resetZoomIcon = _interopRequireDefault(require("./resetZoomIcon"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
// Copyright (c) 2017 Uber Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

/* eslint-enable react/no-unused-prop-types */

var LENGTH_TARGET_PX = 80;
function getMapSize(props) {
  var ch = props.contentHeight,
    cw = props.contentWidth;
  if (ch > cw) {
    return {
      height: LENGTH_TARGET_PX,
      width: LENGTH_TARGET_PX * cw / ch
    };
  }
  return {
    height: LENGTH_TARGET_PX * ch / cw,
    width: LENGTH_TARGET_PX
  };
}
function getViewTransform(props, displaySize) {
  var ch = props.contentHeight,
    cw = props.contentWidth,
    vh = props.viewportHeight,
    vw = props.viewportWidth,
    _props$k = props.k,
    k = _props$k === void 0 ? 1 : _props$k,
    _props$x = props.x,
    x = _props$x === void 0 ? 1 : _props$x,
    _props$y = props.y,
    y = _props$y === void 0 ? 1 : _props$y;
  var dh = displaySize.height,
    dw = displaySize.width;
  var sch = ch * k;
  var scw = cw * k;
  var left = Math.max(-x / scw, 0);
  var right = Math.min((-x + vw) / scw, 1);
  var top = Math.max(-y / sch, 0);
  var bottom = Math.min((-y + vh) / sch, 1);
  return {
    transform: "\n      translate(".concat((left * dw).toFixed(2), "px, ").concat((top * dh).toFixed(2), "px)\n      scale(").concat(right - left, ", ").concat(bottom - top, ")\n    "),
    transformOrigin: '0 0'
  };
}
function getClassNames(props) {
  var className = props.className,
    classNamePrefix = props.classNamePrefix;
  var base = "".concat(classNamePrefix || 'plexus', "-MiniMap");
  return {
    root: "".concat(base, " ").concat(className || ''),
    item: "".concat(base, "--item"),
    map: "".concat(base, "--map"),
    mapActive: "".concat(base, "--mapActive"),
    button: "".concat(base, "--button")
  };
}
function MiniMap(props) {
  var css = getClassNames(props);
  var mapSize = getMapSize(props);
  var activeXform = getViewTransform(props, mapSize);
  return /*#__PURE__*/React.createElement("div", {
    className: css.root
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(css.item, " ").concat(css.map),
    style: mapSize
  }, /*#__PURE__*/React.createElement("div", {
    className: css.mapActive,
    style: _objectSpread(_objectSpread({}, activeXform), mapSize)
  })), /*#__PURE__*/React.createElement("div", {
    className: "".concat(css.item, " ").concat(css.button),
    onClick: props.viewAll,
    role: "button"
  }, _resetZoomIcon.default));
}
MiniMap.defaultProps = {
  className: '',
  classNamePrefix: 'plexus'
};
var _default = /*#__PURE__*/React.memo(MiniMap);
exports.default = _default;